//Generated File 
export default class GlobalShortcutTargetType{
	static readonly EntityList = `EntityList`;
	static readonly GlobalSearch = `GlobalSearch`;
	static readonly InternalLink = `InternalLink`;
	static readonly Link = `Link`;
	static readonly MenuSearch = `MenuSearch`;
	static readonly NewRecord = `NewRecord`;
	static readonly Record = `Record`;
}
